// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PO7w4","wrapper":"Footer_wrapper__FcYcb","logo":"Footer_logo__Rw9yY","trademark":"Footer_trademark__jAy6w"};